import routeNames from './route-names'
import BaseRouterView from '@/components/base/BaseRouterView'

const StaffMembersTabs = () => import(/* webpackChunkName: "staff-members" */'@/views/staff-member/StaffMembersTabs')
const Logs = () => import(/* webpackChunkName: "staff-members" */'@/views/staff-member/sso/Logs')
const StaffMembers = () => import(/* webpackChunkName: "staff-members" */'@/views/staff-member/StaffMembers')
const StaffMember = () => import(/* webpackChunkName: "staff-members" */'@/views/staff-member/staff-member/StaffMember')
const DeactivateStaffMember = () => import(/* webpackChunkName: "staff-members" */'@/views/staff-member/staff-member/DeactivateStaffMember')
const RequestSipcentricAccount = () => import(/* webpackChunkName: "staff-members" */'@/views/staff-member/staff-member/RequestSipcentricAccount')
const SendSipcentricAccount = () => import(/* webpackChunkName: "staff-members" */'@/views/staff-member/staff-member/SendSipcentricAccount')
const ManageStaffMember = () => import(/* webpackChunkName: "staff-members" */'@/views/staff-member/staff-member/ManageStaffMember')

const SendSsoInvite = () => import(/* webpackChunkName: "staff-members" */'@/views/staff-member/staff-member/SendSsoInvite')
const ResendSsoInvite = () => import(/* webpackChunkName: "staff-members" */'@/views/staff-member/staff-member/ResendSsoInvite')
const CancelSsoInvite = () => import(/* webpackChunkName: "staff-members" */'@/views/staff-member/staff-member/CancelSsoInvite')
const ForcePasswordChange = () => import(/* webpackChunkName: "staff-members" */'@/views/staff-member/staff-member/ForcePasswordChange')
const RemoveMfa = () => import(/* webpackChunkName: "staff-members" */'@/views/staff-member/staff-member/RemoveMfa')
const DeactivateSso = () => import(/* webpackChunkName: "staff-members" */'@/views/staff-member/staff-member/DeactivateSso')
const SendSsoPasswordReset = () => import(/* webpackChunkName: "staff-members" */'@/views/staff-member/staff-member/SendSsoPasswordReset')

const props = (route) => ({
    staffMemberId: parseInt(route.params.staffMemberId)
})

export default {
    path: '/staff-members/staff-members',
    alias: '/staff-members',
    component: StaffMembersTabs,
    children: [
        {
            path: 'sso',
            name: routeNames.SSO_LOGS,
            meta: {title: 'SSO Logs'},
            component: Logs
        },
        {
            path: '/',
            name: routeNames.STAFF_MEMBERS,
            meta: {title: 'Staff Members'},
            component: StaffMembers,
            children: [
                {
                    path: 'create',
                    name: routeNames.STAFF_MEMBER_CREATE,
                    meta: {title: 'Create Staff Member'},
                    component: ManageStaffMember
                },
                {
                    path: ':staffMemberId',
                    component: BaseRouterView,
                    props,
                    children: [
                        {
                            path: '/',
                            name: routeNames.STAFF_MEMBER,
                            props,
                            meta: {title: 'Staff Member Details'},
                            component: StaffMember
                        },
                        {
                            path: 'update',
                            name: routeNames.STAFF_MEMBER_UPDATE,
                            props,
                            meta: {title: 'Update Staff Member'},
                            component: ManageStaffMember
                        },
                        {
                            path: 'request-account',
                            name: routeNames.STAFF_MEMBER_REQUEST_ACCOUNT,
                            props,
                            meta: {title: 'Request Sipcentric Account'},
                            component: RequestSipcentricAccount
                        },
                        {
                            path: 'send-account',
                            name: routeNames.STAFF_MEMBER_SEND_ACCOUNT,
                            props,
                            meta: {title: 'Send Sipcentric Account'},
                            component: SendSipcentricAccount
                        },
                        {
                            path: 'send-sso-invite',
                            name: routeNames.SSO_SEND_INVITE,
                            props,
                            meta: {title: 'Send SSO Invite'},
                            component: SendSsoInvite
                        },
                        {
                            path: 'resend-sso-invite',
                            name: routeNames.SSO_RESEND_INVITE,
                            props,
                            meta: {title: 'Resend SSO Invite'},
                            component: ResendSsoInvite
                        },
                        {
                            path: 'cancel-sso-invite',
                            name: routeNames.SSO_CANCEL_INVITE,
                            props,
                            meta: {title: 'Cancel SSO Invite'},
                            component: CancelSsoInvite
                        },
                        {
                            path: 'force-password-change',
                            name: routeNames.SSO_FORCE_PASSWORD_CHANGE,
                            props,
                            meta: {title: 'Force Password Change'},
                            component: ForcePasswordChange
                        },
                        {
                            path: 'remove-mfa',
                            name: routeNames.SSO_REMOVE_MFA,
                            props,
                            meta: {title: 'Remove MFA'},
                            component: RemoveMfa
                        },
                        {
                            path: 'deactivate-sso',
                            name: routeNames.SSO_DEACTIVATE,
                            props,
                            meta: {title: 'Deactivate SSO'},
                            component: DeactivateSso
                        },
                        {
                            path: 'send-password-reset',
                            name: routeNames.SSO_SEND_PASSWORD_RESET,
                            props,
                            meta: {title: 'Send Password Reset'},
                            component: SendSsoPasswordReset
                        },
                        {
                            path: 'deactivate',
                            name: routeNames.STAFF_MEMBERS_DEACTIVATE,
                            props,
                            meta: {title: 'Deactivate Staff Member'},
                            component: DeactivateStaffMember
                        }
                    ]
                }
            ]
        }
    ]
}
